import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class LevelBackground extends Phaser.GameObjects.Container {
  constructor(scene, parentRef) {
    super(scene);
    scene.add.existing(this);

    this.scene = scene;
    this.parentRef = parentRef;

    this.solidColorShape = ABCyaPhaser.Graphics.addRect(0, 0, this.scene.mid.x * 2,this.scene.mid.y * 2, this.bgColor, this.parentRef, { x: 0, y: 0 });
    this.parentRef.moveTo(this.solidColorShape, 0);
    this.corners = [];
  }

  setUpBackground(color,cornerNames) {
    this.bgColor = color;
    if (this.corners.length > 0) {
      while (this.corners.length > 0) {
        const c = this.corners.shift();
        if (c !== null) c.destroy();
      }
    }
    this.corners = [];

    // get corner image name

    for (let i = 0; i < cornerNames.length; i++) {
      const cornerName = cornerNames[i];
      let corner = null;
      if (cornerName !== 'blank') {
        corner = ABCyaPhaser.Images.addImage(0, 0, cornerName, this.parentRef).setOrigin(0, 0);

        let cornerId;
        switch (i) {
          case 0:
            cornerId = 'top-left';
            corner.dirX = 1;
            corner.dirY = -1;
            break;
          case 1:
            cornerId = 'top-right';
            corner.dirX = -1;
            corner.dirY = -1;
            break;
          case 2:
            cornerId = 'bottom-right';
            corner.dirX = -1;
            corner.dirY = 1;
            break;
          case 3:
            cornerId = 'bottom-left';
            corner.dirX = 1;
            corner.dirY = 1;
            break;
        }
        corner.id = cornerId;
      }

      // if (corner) this.parentRef.addAt(corner, this.parentRef.list.length);
      this.corners.push(corner);
    }

    this.layoutBackground();
  };

  layoutBackground() {
    this.solidColorShape.destroy();
    this.solidColorShape = ABCyaPhaser.Graphics.addRect(0, 0, this.scene.mid.x * 2,this.scene.mid.y * 2, this.bgColor, this.parentRef, { x: 0, y: 0 });
    this.parentRef.moveTo(this.solidColorShape, 0);

    for (let i = 0; i < this.corners.length; i++) {
      const cornerClip = this.corners[i];
      if (cornerClip !== null) {
        cornerClip.scaleX = cornerClip.dirX;
        cornerClip.scaleY = cornerClip.dirY;
        cornerClip.x = cornerClip.id === 'top-left' || cornerClip.id === 'bottom-left' ? 0 : this.scene.mid.x * 2;
        cornerClip.y = cornerClip.id === 'bottom-right' || cornerClip.id === 'bottom-left' ? this.scene.mid.y * 2 - (cornerClip.getBounds().height * cornerClip.scaleY) : 0;
      }
    }
  };
}